import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71afc02f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "member-card" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "member-global-name" }
const _hoisted_5 = { class: "member-username" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "guild-name" }
const _hoisted_9 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { class: "guild-name" }
const _hoisted_12 = { class: "member-flex" }
const _hoisted_13 = { class: "subtitle" }
const _hoisted_14 = { class: "subtitle" }
const _hoisted_15 = { class: "member-flex" }

import {onMounted, Ref, ref} from "vue";
import {LeaderboardMember} from "@/types/LeaderboardMember";
import config from "@/config.json";
import {useRoute} from "vue-router";
import {UpdateBalanceForm} from "@/types/UpdateBalanceForm";
import UpdateBalance from "@/components/balances/UpdateBalance.vue";
import DeleteBalance from "@/components/balances/DeleteBalance.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderboardMemberView',
  setup(__props) {

const route = useRoute()
let loading = ref(true)
let guildName = ref()
let member: Ref<LeaderboardMember> = ref({} as LeaderboardMember)
let access = ref(false)

function updateBalance(balance: UpdateBalanceForm) {
  member.value.balance = balance.balance;
  if (balance.resetXP) member.value.xp = 0;
  return load();
}

function deleteBalance() {
  window.location.replace(`/leaderboard/${route.params.id}`)
}

async function load() {
  let response = await fetch(`${config.API}/private/leaderboard/${route.params.id}/${route.params.user}`, {
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  let body = await response.json()
  if (!response.ok) return window.location.replace('/@me');
  guildName.value = body.guildName;
  member.value = body.leader;
  access.value = body.access;
  let guildResponse = await fetch(`${config.API}/private/guilds/${route.params.id}/info`, {
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  if (guildResponse.ok) access.value = true
}

onMounted(async () => {
  loading.value = true;
  await load();
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            size: 80,
            width: 6,
            indeterminate: ""
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_img, {
              "lazy-src": _unref(member).user.avatar,
              src: _unref(member).user.avatar,
              class: "member-avatar item-center"
            }, null, 8, ["lazy-src", "src"]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(member).user.global_name), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(member).user.username), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('LeaderboardMember.server')), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(guildName)), 1)
            ]),
            (_unref(member).number !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('LeaderboardMember.rank')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(member).number), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('LeaderboardMember.balance')), 1),
                _createElementVNode("div", null, _toDisplayString(Number(_unref(member).balance).toLocaleString(_ctx.$i18n.locale)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('LeaderboardMember.xp')), 1),
                _createElementVNode("div", null, _toDisplayString(Number(_unref(member).xp).toLocaleString(_ctx.$i18n.locale)), 1)
              ])
            ]),
            _createVNode(_component_v_divider, { class: "mt-2 mb-2" }),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                color: "primary",
                size: "40",
                to: `/leaderboard/${_unref(route).params.id}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("keyboard_return")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]),
              (_unref(access))
                ? (_openBlock(), _createBlock(UpdateBalance, {
                    key: 0,
                    member: _unref(member),
                    onUpdate: updateBalance
                  }, null, 8, ["member"]))
                : _createCommentVNode("", true),
              (_unref(access))
                ? (_openBlock(), _createBlock(DeleteBalance, {
                    key: 1,
                    member: _unref(member),
                    onDelete: deleteBalance
                  }, null, 8, ["member"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}
}

})